export const priceformat = (price: number) => {
  if (price <= 999999) return `${(price / 1000).toFixed(0)} thousand`;
  else if (price <= 999999999) return `${(price / 1000000).toFixed(0)} million`;
  else if (price <= 999999999999) return `${(price / 1000000000).toFixed(0)} billion`;
  //   else if (price <= 999999999) return (price / 1000000).toFixed(0);
  //   else if (price <= 999999999) return (price / 1000000).toFixed(0);
};
